import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
    selectLocation(event) {
        event.preventDefault();
        const target = event.target;
        target.dispatchEvent(new Event("location-menu:select", {
            bubbles: true,
        }));
    }
}
